import { forwardRef } from 'react';
import MuiAlert, { AlertProps as MuiAlertProps } from '@material-ui/lab/Alert';

type NotificationProps = MuiAlertProps & {
  message: string;
};

const Notification = forwardRef<typeof MuiAlert, NotificationProps>(
  ({ message, ...props }, ref) => (
    /* eslint-disable react/jsx-props-no-spreading */
    <MuiAlert ref={ref} {...props}>
      {message}
    </MuiAlert>
  )
);

export default Notification;
